import axios from 'axios';

// A "Buy All Digital" option (e.g. "All Digital", or the $99 "Buy All Your Photos" bonus)
// bundles EVERY photo as a digital image. Picking a background + overlay per pose in the
// builder is ~140 clicks for a full senior session, so these options skip the builder:
// the order package is created server-side (one sheet per photo, backgrounds auto-cycled)
// and the customer is sent straight to checkout, where they can still edit any pose.
//
// digital_images_only is the same flag the server's /buy_all branch keys on, so the two
// stay in lock-step. The other "digital" options (Digital Collection, etc.) are NOT
// digital_images_only and still go through the normal builder.
export const isBuyAllDigital = (option) => !!option?.digitalImagesOnly;

// POST the option to the /buy_all endpoint, which auto-creates one digital sheet per photo
// (cycling the first 8 backgrounds). Shared by the "All Digital" package selection and the
// $99 upsell so they behave identically.
export function addBuyAllToCart({
  cartId, packageId, optionId, studentId, season,
}) {
  // The endpoint is /api/v1/carts/:id/buy_all — rely on the app's global
  // axios.defaults.baseURL ('/api/v1'); do NOT override baseURL (that 404s the route).
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  return axios.post(
    `/carts/${cartId}/buy_all`,
    {
      package_id: packageId,
      option_id: optionId,
      student_id: studentId,
      season,
    },
    { headers: { 'X-CSRF-Token': csrfToken } },
  );
}
